import settings from './settings.middleware.js';
import themes from './themes.middleware.js';

// eslint-disable-next-line import/no-anonymous-default-export
export default [settings, themes];
